/**
 * Product Entry JS
 * **/

import axios from 'axios'
import { stringify } from 'qs'
import { openCart } from '../components/cart.js'

/** Product Form **/
const productForm = document.querySelector('[data-product-form]')
const addToCart = document.querySelector('[data-add-to-cart]')
const variantSelector = document.querySelector('#purchasableId')
const productOption = document.querySelector('[data-product-option]')
const quantity = productForm.querySelector('[name="qty"]')

const client = axios.create({
    headers: {
        'X-CSRF-Token': window.csrfToken
    },
    transformRequest: [
        function(data) {
            return stringify(data)
        },
    ],
})

// Submit
const handleFormSubmit = async () => {
    const purchasableId = variantSelector.value
    if(purchasableId) {
        const response = await client.post('', {
            action: "commerce/cart/update-cart",
            purchasableId,
            options: {
                productOption: productOption ? productOption.value : null
            },
            qty: quantity.value
        }).catch(error => console.error(error))
    }
}

// Add to Cart
// uses htmx from Sprig library
productForm.addEventListener('submit', async function(event) {
    event.preventDefault();
    addToCart.setAttribute('disabled', 'disabled')
    addToCart.innerHTML = 'Adding...'
    console.log(addToCart)
    await handleFormSubmit()
    htmx.trigger(document.querySelector('[data-cart]'), 'refresh')
    setTimeout(() => openCart(), 1000)
    addToCart.innerHTML = 'Add to Cart'
    addToCart.removeAttribute('disabled')
})
